import { create } from "zustand";

export interface BasicUser {
  id: string;
  name: string;
  email: string;
  status: string;
  emailConfirmed: boolean;
  enabled: boolean;
  trackingId: string;

  countryState?: string;
  timezone?: string;
  mlsId?: string;
  phoneNumber?: string;
  officeName?: string;
  subscriptionPlanId?: string;
}

export interface UsersQueryParams {
  nameFilter?: string;
  emailFilter?: string;
  trackingIdFilter?: string;
  limit?: number;
  page: number;
}

interface UsersState {
  users: BasicUser[];
  usersQueryParams: UsersQueryParams;
  setUsers: (user: BasicUser[]) => void;
  updateUsersQueryParams: (params: Partial<UsersQueryParams>) => void;
}

export const usersInitialState = {
  users: [],
  usersQueryParams: {
    nameFilter: undefined,
    emailFilter: undefined,
    trackingIdFilter: undefined,
    limit: 10,
    page: 0,
  },
};

export const useUsersStore = create<UsersState>((set) => ({
  users: usersInitialState.users,
  usersQueryParams: usersInitialState.usersQueryParams,
  setUsers: (users) =>
    set(() => ({
      users,
    })),
  updateUsersQueryParams: (params) =>
    set((state) => ({
      usersQueryParams: { ...state.usersQueryParams, ...params },
    })),
}));
